<template>
  <div class="right-menu-big uk-height-1-1">
    <div class="background-click" @click="toggleMenu"></div>
    <div class="uk-flex uk-flex-column uk-flex-between uk-height-1-1">
      <div>
        <DesktopRightMenuOpenedHeader @change="toggleMenu" />
        <DesktopRightMenuOpenedCommunity
          v-for="community in communities"
          :key="community.id"
          :community="community"
        />
        <RightMenuLogoutButton className="right-menu-exit" />
      </div>
      <BClock size="big" />
    </div>
  </div>
</template>

<script>
import DesktopRightMenuOpenedCommunity from '@/views/layout/desktop/right_menu/opened/DesktopRightMenuOpenedCommunity'
import DesktopRightMenuOpenedHeader from '@/views/layout/desktop/right_menu/opened/DesktopRightMenuOpenedHeader'
import RightMenuLogoutButton from '@/views/layout/desktop/right_menu/RightMenuLogoutButton'
import {Role} from '@/views/variables/roles'
import BClock from '@/components/b-clock'

import {mapActions} from 'vuex'

export default {
  name: 'DesktopRightMenuOpened',
  components: {
    RightMenuLogoutButton,
    DesktopRightMenuOpenedHeader,
    DesktopRightMenuOpenedCommunity,
    BClock
  },
  data: () => ({
    communities: []
  }),
  methods: {
    ...mapActions({
      fetchCommunities: 'community/CHAIRMAN_COMMUNITIES'
    }),
    toggleMenu() {
      this.$emit('change', false)
    },
    getCommunities() {
      this.fetchCommunities()
        .then(resp => {
          this.communities = resp
        })
        .catch(() => (this.communities = []))
    }
  },
  mounted() {
    if (this.$store.state.auth.user.roles[0] === Role.Chairman) {
      this.getCommunities()
    }
  }
}
</script>

<style lang="scss" scoped>
.background-click {
  &:after {
    content: '';
    position: fixed;
    position: -ms-device-fixed;
    width: 100vw;
    height: 100vh;
    background-color: rgba(122, 122, 122, 0.3);
    top: 0;
    left: 50%;
    right: 50%;
    margin: 0 -50vw;
    z-index: -1;
  }
}
</style>
